import { render, staticRenderFns } from "./ViolationRule.vue?vue&type=template&id=572f788c&scoped=true"
import script from "./ViolationRule.vue?vue&type=script&setup=true&lang=js"
export * from "./ViolationRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViolationRule.vue?vue&type=style&index=0&id=572f788c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f788c",
  null
  
)

export default component.exports